import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import './index.less';
import App from './components/App/App';
import { AppProvider } from './context/context';

ReactDOM.render(
  <AppProvider>
    <BrowserRouter
      getUserConfirmation={() => {
        /* Empty callback to block the default browser prompt */
      }}
    >
      <App />
    </BrowserRouter>
  </AppProvider>,
  document.getElementById('root')
);
